export const useUrlQueryParam = (queryParamName: string): string | null => {
  const url = new URL(window.location.href);
  return url.searchParams.get(queryParamName);
};
